const MixArray = [
    {
        id: 1,
        src: '../../assets-gbeaks/1.png',
    },
    {
        id: 2,
        src: '../../assets-gbeaks/2.png',
    },
    {
        id: 3,
        src: '../../assets-gbeaks/3.png',
    },
    {
        id: 4,
        src: '../../assets-gbeaks/4.png',
    },
    {
        id: 5,
        src: '../../assets-gbeaks/5.png',

    },

    {
        id: 6,
        src: '../../assets-gbeaks/6.png',
    },
    {
        id: 7,
        src: '../../assets-gbeaks/7.png',
    },
    {
        id: 8,
        src: '../../assets-gbeaks/8.png',
    },
    {
        id: 9,
        src: '../../assets-gbeaks/9.png',
    },
    {
        id: 10,
        src: '../../assets-gbeaks/10.png',

    },

    {
        id: 11,
        src: '../../assets-gbeaks/11.png',
    },
    {
        id: 12,
        src: '../../assets-gbeaks/12.png',
    },
    {
        id: 13,
        src: '../../assets-gbeaks/13.png',
    },
    {
        id: 14,
        src: '../../assets-gbeaks/14.png',
    },
    {
        id: 15,
        src: '../../assets-gbeaks/15.png',

    },
    {
        id: 16,
        src: '../../assets-gbeaks/16.png',
    },
    {
        id: 17,
        src: '../../assets-gbeaks/17.png',
    },
    {
        id: 18,
        src: '../../assets-gbeaks/18.png',
    },
    {
        id: 19,
        src: '../../assets-gbeaks/19.png',
    },
    {
        id: 20,
        src: '../../assets-gbeaks/20.png',
    },

    {
        id: 21,
        src: '../../assets-gbeaks/21.png',
    },
    {
        id: 22,
        src: '../../assets-gbeaks/22.png',
    },
    {
        id: 23,
        src: '../../assets-gbeaks/23.png',
    },
    {
        id: 24,
        src: '../../assets-gbeaks/24.png',
    },
    {
        id: 25,
        src: '../../assets-gbeaks/25.png',

    },

    {
        id: 26,
        src: '../../assets-gbeaks/26.png',
    },
    {
        id: 27,
        src: '../../assets-gbeaks/27.png',
    },
    // {
    //     id: 319,
    //     src: '../../assets-gbeaks/319.png',
    // },
    // {
    //     id: 329,
    //     src: '../../assets-gbeaks/329.png',
    // },
    // {
    //     id: 339,
    //     src: '../../assets-gbeaks/339.png',
    // },

    // {
    //     id: 349,
    //     src: '../../assets-gbeaks/349.png',
    // },
    // {
    //     id: 359,
    //     src: '../../assets-gbeaks/359.png',
    // },
    // {
    //     id: 369,
    //     src: '../../assets-gbeaks/369.png',
    // },
    // {
    //     id: 379,
    //     src: '../../assets-gbeaks/379.png',
    // },
    // {
    //     id: 389,
    //     src: '../../assets-gbeaks/389.png',

    // },
    // {
    //     id: 399,
    //     src: '../../assets-gbeaks/399.png',

    // },

    // {
    //     id: 700,
    //     src: '../../assets-gbeaks/700.png',
    // },
    // {
    //     id: 800,
    //     src: '../../assets-gbeaks/800.png',
    // },
    // {
    //     id: 900,
    //     src: '../../assets-gbeaks/900.png',
    // },
    // {
    //     id: 1000,
    //     src: '../../assets-gbeaks/1000.png',
    // },
    // {
    //     id: 1100,
    //     src: '../../assets-gbeaks/1100.png',
    // },

    // {
    //     id: 1200,
    //     src: '../../assets-gbeaks/1200.png',
    // },
    // {
    //     id: 1300,
    //     src: '../../assets-gbeaks/1300.png',
    // },
    // {
    //     id: 1600,
    //     src: '../../assets-gbeaks/1600.png',
    // },
    // {
    //     id: 1800,
    //     src: '../../assets-gbeaks/1800.png',
    // },
    // {
    //     id: 1900,
    //     src: '../../assets-gbeaks/1900.png',

    // },
    // {
    //     id: 1910,
    //     src: '../../assets-gbeaks/1910.png',

    // },

    // {
    //     id: 1990,
    //     src: '../../assets-gbeaks/1990.png',
    // },
    // {
    //     id: 1991,
    //     src: '../../assets-gbeaks/1991.png',
    // },
    // {
    //     id: 1992,
    //     src: '../../assets-gbeaks/1992.png',
    // },
    // {
    //     id: 1993,
    //     src: '../../assets-gbeaks/1993.png',
    // },
    // {
    //     id: 1994,
    //     src: '../../assets-gbeaks/1994.png',
    // },

    // {
    //     id: 1995,
    //     src: '../../assets-gbeaks/1995.png',
    // },
    // {
    //     id: 1996,
    //     src: '../../assets-gbeaks/1996.png',
    // },
    // {
    //     id: 1997,
    //     src: '../../assets-gbeaks/1997.png',
    // },
    // {
    //     id: 1998,
    //     src: '../../assets-gbeaks/1998.png',
    // },
    // {
    //     id: 1999,
    //     src: '../../assets-gbeaks/1999.png',

    // },
  
]
export default MixArray